export enum AUTH_TOKEN {
  ACCESS = 'access_token',
  REFRESH = 'refresh_token',
}

export const TOKEN_EXPIRATIONS: Record<AUTH_TOKEN, number> = {
  access_token: 60 * 5, // 5 Minutes
  refresh_token: 60 * 60 * 24 * 7, // 1 Week
};
